import MaterialLoader from "../material-loader.js";
import MultiMaterial from "./multi-material.js";

class MaterialMultiLoader extends MaterialLoader {
    constructor(loaders) {
        super();
        this._loaders = Object.assign({}, loaders);
    }

    load() {
        const materials = {};

        for (const key in this._loaders) {
            materials[key] = this._loaders[key].load();
        }

        return new MultiMaterial(materials);
    }

    unload(material) {
        for (const key in this._loaders) {
            this._loaders[key].unload(material.materials[key]);
        }
    }
}

export default MaterialMultiLoader;
